
import Vue from "vue";

export default Vue.extend({
  props: {
    backgroundColorClass: {
      type: String,
      default: "bg-[#0c5c51]",
    },
    backgroundHoverColorClass: {
      type: String,
      default: "hover:bg-[#083e36]",
    },
    textColorClass: {
      type: String,
      default: "text-white",
    },
  },
});
